<template>
  <footer style="background: #1b7dc9" class="white--text mx-n5 py-8">
    <v-container>
      <div class="d-flex flex-column flex-md-row justify-space-between">
        <div class="d-flex flex-column flex-md-row">
          <h4 class="mr-md-16 mb-6 mb-md-0">ООО "АтисТрейд"</h4>
          <div>
            <p>
              <a
                  href="tel:+78002004132"
                  class="white--text text-decoration-none"
              >8 800 200 41 32</a
              >
            </p>
            <p style="max-width: 270px; font-size: 14px">
              E-mail для вопросов и предложений о сотрудничестве:
              <a href="mailto:info@atistrade.ru" class="white--text"
              >info@atistrade.ru</a
              >
            </p>
          </div>
        </div>
        <div class="d-flex flex-column align-start" style="font-size: 14px">
          <a href="https://disk.yandex.ru/d/EqGX4M_aMiPJ9g" target="_blank" class="white--text"
          >Документы Онлайн-платформы ООО "АтисТрейд"</a
          >
        </div>
      </div>
    </v-container>
  </footer>
</template>

<script>
export default {
}
</script>